import * as React from "react";
import { useState } from "react";
import { Menu, X } from "lucide-react";

import { Link } from "react-router-dom";

const HeaderLanding = React.forwardRef(({ className, type, ...props }, ref) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header
      className="sticky top-0 z-50 bg-white border-b-2 border-black"
      data-testid="home-header"
    >
      <div className="px-4 sm:px-8 max-w-7xl mx-auto">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="font-black text-2xl tracking-tighter">
            <img className="w-36" src="/images/logo.png" alt="Logo" />
          </Link>

          {/* Desktop Menu */}
          <nav className="hidden lg:flex items-center gap-6">
            <Link
              to="/buscar"
              className="text-sm font-bold uppercase tracking-wider hover:text-[#FF3333] transition-colors"
            >
              Verificador de Boletos
            </Link>
            <Link
              to="/metodos-de-pago"
              className="text-sm font-bold uppercase tracking-wider hover:text-[#FF3333] transition-colors"
            >
              Métodos de Pago
            </Link>
            <Link
              to="/contacto"
              className="text-sm font-bold uppercase tracking-wider hover:text-[#FF3333] transition-colors"
            >
              Contacto
            </Link>
            <Link
              to="/contacto"
              className="text-sm font-bold uppercase tracking-wider hover:text-[#FF3333] transition-colors"
            >
              Faqs
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? (
              <X className="w-6 h-6" />
            ) : (
              <Menu className="w-6 h-6" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <nav className="lg:hidden py-4 border-t-2 border-black">
            <div className="flex flex-col gap-4">
              <Link
                to="/buscar"
                className="text-sm font-bold uppercase tracking-wider hover:text-[#FF3333] transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                Verificador de Boletos
              </Link>
              <Link
                to="/metodos-de-pago"
                className="text-sm font-bold uppercase tracking-wider hover:text-[#FF3333] transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                Métodos de Pago
              </Link>
              <Link
                to="/contacto"
                className="text-sm font-bold uppercase tracking-wider hover:text-[#FF3333] transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                Contacto
              </Link>
              <Link
                to="/contacto"
                className="text-sm font-bold uppercase tracking-wider hover:text-[#FF3333] transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                Faqs
              </Link>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
});
HeaderLanding.displayName = "HeaderLanding";

export { HeaderLanding };
